import React from 'react';

import { IconProps } from './types';

export const CellUsersIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="26"
        viewBox="0 0 26 26"
        width="26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M12.1875 21.125C9.2803 22.475 5.2516 22.1237 3.25 21.125C2.5898 20.795 1.625 19.8978 1.625 19.0938C1.625 17.4095 5.3024 16.25 7.6553 16.25C10.0124 16.25 13.7067 17.4095 13.7067 19.0938C13.7067 19.8936 12.8519 20.8161 12.1875 21.125Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M11.375 9.75C11.375 11.5442 9.9192 13 8.125 13C6.3307 13 4.875 11.5442 4.875 9.75C4.875 7.9557 6.3307 6.5 8.125 6.5C9.9192 6.5 11.375 7.9557 11.375 9.75Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M21.125 8.125C21.125 9.9192 19.6692 11.375 17.875 11.375C16.0808 11.375 14.625 9.9192 14.625 8.125C14.625 6.3307 16.0808 4.875 17.875 4.875C19.6692 4.875 21.125 6.3307 21.125 8.125Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M17.5153 14.625C15.3656 14.625 12.1198 15.5898 11.5697 17.0414C12.7884 17.5407 13.7067 18.2516 13.7067 19.0938C13.7067 19.3265 13.6602 19.5677 13.5798 19.7962C15.9031 20.4902 19.4239 20.668 21.9375 19.5C22.6019 19.1911 23.5625 18.2686 23.5625 17.4688C23.5625 15.7845 19.8682 14.625 17.5153 14.625Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
